import React from 'react'

const montserratStyle = { fontFamily: 'Montserrat, sans-serif', color: '#1E1E1E' }

const freqGeneral = {
  title: 'Frecuencia promedio (todos los usuarios)',
  value: '3,8',
  diff: 9,
  prev: '3,6',
  isPositive: true,
}

const freqRecurrent = {
  title: 'Frecuencia promedio de usuarios recurrentes',
  value: '4,1',
  diff: 9,
  prev: '3,9',
  isPositive: true,
}

const freqByLevel = [
  { nivel: 'Nivel 1', value: '1,15', diff: 12, prev: '1,13', isPositive: true },
  { nivel: 'Nivel 2', value: '1,82', diff: 12, prev: '1,73', isPositive: true },
  { nivel: 'Nivel 3', value: '4,35', diff: -1, prev: '4,73', isPositive: false },
]

export const AverageFrequency = () => (
  <div className="flex flex-col gap-6 w-full">
    {/* Tarjetas superiores */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
      {[freqGeneral, freqRecurrent].map(f => (
        <div
          key={f.title}
          className="bg-white rounded-2xl shadow p-6 flex flex-col"
          style={montserratStyle}
        >
          <span className="text-base font-bold mb-1">{f.title}</span>
          <span className="text-3xl font-extrabold mb-2">{f.value}</span>
          <div className="flex items-center gap-2">
            <span
              className="font-bold rounded-lg px-2 py-1 flex items-center text-base"
              style={{
                ...montserratStyle,
                background: f.isPositive ? '#C1FD96CC' : '#FFDBDB',
                color: f.isPositive ? '#1E1E1E' : '#E53935',
              }}
            >
              {f.isPositive ? (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#47B960"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-1"
                >
                  <path d="M6 15l6-6 6 6" />
                </svg>
              ) : (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#E53935"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-1"
                >
                  <path d="M6 9l6 6 6-6" />
                </svg>
              )}
              {f.isPositive ? `↑${f.diff}%` : `↓${Math.abs(f.diff)}%`}
            </span>
            <span className="text-gray-600 text-base">({f.prev} del mes anterior)</span>
          </div>
        </div>
      ))}
    </div>
    {/* Título de la sección inferior */}
    <span className="text-base font-bold mt-2 mb-1" style={montserratStyle}>
      Frecuencia promedio de usuarios recurrentes
    </span>
    {/* Tarjetas inferiores */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {freqByLevel.map(n => (
        <div
          key={n.nivel}
          className="bg-white rounded-2xl shadow p-6 flex flex-col min-w-[100px]"
          style={montserratStyle}
        >
          <span className="text-base font-bold mb-1">{n.nivel}</span>
          <span className="text-2xl font-extrabold mb-1">{n.value}</span>
          <div className="flex items-center gap-2">
            <span
              className="font-bold rounded-lg px-2 py-1 flex items-center text-base"
              style={{
                ...montserratStyle,
                background: n.isPositive ? '#C1FD96CC' : '#FFDBDB',
                color: n.isPositive ? '#1E1E1E' : '#E53935',
              }}
            >
              {n.isPositive ? (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#47B960"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-1"
                >
                  <path d="M6 15l6-6 6 6" />
                </svg>
              ) : (
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#E53935"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="mr-1"
                >
                  <path d="M6 9l6 6 6-6" />
                </svg>
              )}
              {n.isPositive ? `↑${n.diff}%` : `↓${Math.abs(n.diff)}%`}
            </span>
            <span className="text-gray-600 text-base">({n.prev} del mes anterior)</span>
          </div>
        </div>
      ))}
    </div>
  </div>
)
